<div class="about">
  <!-- Intro -->
  <div class="about-intro">
    <div class="content-text">
      <h1 translate>about.intro.title</h1>
      <p translate>about.intro.text</p>
    </div>
    <div class="content-image">
      <img src="assets/images/about/intro.png" alt="" />
    </div>
  </div>

  <!-- Intro2 -->
  <div class="bluebg" id="here">
    <div class="about-intro2">
      <div class="content-image">
        <div class="content-image-text">
          <p translate>about.intro2.mission</p>
          <h2 translate>about.intro2.title</h2>
        </div>
        <img src="assets/images/about/intro2.png" alt="" />
      </div>
    </div>
  </div>

  <!-- BlackPart -->
  <div class="about-black">
    <h2 translate>about.black.title</h2>
    <p translate>about.black.text</p>
  </div>

  <!-- Card grid -->
  <div class="about-card">
    <h2 translate>about.card.title</h2>
    <div class="about-card-grid">
      <div class="card">
        <img src="assets/images/about/grid-1.png" alt="" />
        <h4 translate>about.card.one.title</h4>
        <p [innerHTML]="'about.card.one.text' | translate"></p>
      </div>
      <div class="card">
        <img src="assets/images/about/grid-2.png" alt="" />
        <h4 translate>about.card.two.title</h4>
        <p [innerHTML]="'about.card.two.text' | translate"></p>
      </div>
      <div class="card">
        <img src="assets/images/about/grid-3.png" alt="" />
        <h4 translate>about.card.three.title</h4>
        <p [innerHTML]="'about.card.three.text' | translate"></p>
      </div>
      <div class="card">
        <img src="assets/images/about/grid-4.png" alt="" />
        <h4 translate>about.card.four.title</h4>
        <p [innerHTML]="'about.card.four.text' | translate"></p>
      </div>
      <div class="card">
        <img src="assets/images/about/grid-5.png" alt="" />
        <h4 translate>about.card.five.title</h4>
        <p [innerHTML]="'about.card.five.text' | translate"></p>
      </div>
      <div class="card">
        <img src="assets/images/about/grid-6.png" alt="" />
        <h4 translate>about.card.six.title</h4>
        <p [innerHTML]="'about.card.six.text' | translate"></p>
      </div>
    </div>
  </div>

  <!-- Bloc vision -->
  <div class="about-vision">
    <h2 translate>about.vision.title</h2>
    <p translate>about.vision.text</p>
    <div class="grid">
      <div class="grid-card">
        <svg
          width="30"
          height="24"
          viewBox="0 0 30 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5402 2.12211C14.0866 2.63909 14.5784 3.20571 15.0001 3.76357C15.4218 3.20571 15.9136 2.63909 16.46 2.12212C17.4965 1.14139 18.7296 0.339325 20.0538 0.114686C22.076 -0.228369 24.1553 0.204894 25.8602 1.32455C27.5651 2.44421 28.7646 4.16429 29.2099 6.12778C29.6551 8.09128 29.3119 10.1474 28.2514 11.8695L28.2384 11.8912C24.9456 17.1617 16.0999 23.3948 15.4446 23.8565C15.4337 23.8642 15.4251 23.8703 15.4188 23.8747C15.302 23.9564 15.1621 24.0002 15.0186 24H14.9816C14.8382 23.9999 14.6983 23.9562 14.5814 23.8747C14.1961 23.6078 5.10933 17.2548 1.76177 11.8912L1.7488 11.8695C0.688296 10.1474 0.345051 8.09128 0.790302 6.12778C1.23555 4.16429 2.43511 2.44421 4.14001 1.32455C5.8449 0.204894 7.92422 -0.228369 9.94641 0.114686C11.2706 0.339325 12.5037 1.14138 13.5402 2.12211ZM3.60573 10.7661L3.59655 10.7507L3.58801 10.7368C2.82232 9.49349 2.57716 8.01511 2.89682 6.60547C3.21668 5.19494 4.08115 3.94736 5.32571 3.13002C6.57159 2.31181 8.09769 1.99192 9.58514 2.24426C10.7643 2.44429 12.141 3.56339 13.277 5.06613L15.0001 7.34544L16.7232 5.06613C17.8592 3.56339 19.2359 2.44429 20.4151 2.24426C21.9025 1.99192 23.4286 2.31181 24.6745 3.13002C25.9191 3.94736 26.7835 5.19494 27.1034 6.60547C27.423 8.01511 27.1779 9.49349 26.4122 10.7368L26.4036 10.7507L26.3953 10.7647C24.9138 13.1261 22.0474 15.8603 19.3314 18.1338C17.5532 19.6222 15.9344 20.836 14.9985 21.5182C14.068 20.841 12.4483 19.6274 10.6688 18.1379C7.95299 15.8646 5.08706 13.1298 3.60573 10.7661Z"
            fill="#1A1918"
          />
        </svg>
        <h3 translate>about.vision.card.one.title</h3>
        <p translate>about.vision.card.one.text</p>
      </div>
      <div class="grid-card">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.1968 10.1095L27.1615 10.0741L27.1968 10.1095C27.4242 9.88208 27.5496 9.57928 27.5496 9.25762C27.5496 8.93601 27.4242 8.63341 27.1968 8.40598L24.9158 6.125L23.3953 4.60442L19.5938 0.802855C19.3663 0.575352 19.0637 0.45 18.7419 0.45C18.4202 0.45 18.1175 0.575347 17.8902 0.802794C17.4209 1.27209 17.4205 2.03514 17.8884 2.505L17.8884 2.50507L25.4941 10.1106L25.4942 10.1106C25.7215 10.3373 26.0237 10.4624 26.3448 10.4624C26.6665 10.4624 26.9693 10.337 27.1968 10.1095ZM8.40506 27.1973L8.44041 27.1619L8.40506 27.1973C8.63244 27.4246 8.93517 27.5499 9.25689 27.55C9.57877 27.55 9.88156 27.4245 10.1091 27.197L10.0738 27.1617L10.1091 27.197C10.5772 26.7289 10.5784 25.9684 10.1134 25.4982L10.1133 25.498L2.50508 17.8898L2.50505 17.8898C2.27763 17.6628 1.97544 17.5376 1.65417 17.5376C1.33243 17.5376 1.02976 17.663 0.802255 17.8907C0.332542 18.3605 0.332619 19.1246 0.802261 19.5944L0.837621 19.5591L0.802265 19.5944L5.6403 24.4325L6.12461 24.9168L8.40506 27.1973ZM11.4541 24.1641L11.454 24.1641L11.455 24.165L12.9666 25.6766C13.1941 25.9041 13.4969 26.0295 13.8187 26.0295C14.1405 26.0295 14.4432 25.9041 14.6708 25.6766L14.6354 25.6412L14.6708 25.6766C14.8981 25.4492 15.0235 25.1463 15.0235 24.8247C15.0235 24.5029 14.8982 24.2003 14.6709 23.973L14.6355 24.0083L14.6709 23.9729L10.6791 19.9812L7.82736 17.1295L7.79201 17.1648L7.82736 17.1295L4.0264 13.3287C3.79902 13.1013 3.49642 12.9759 3.17482 12.9759C2.85302 12.9759 2.55015 13.1014 2.32252 13.329L2.32251 13.329C1.85293 13.7987 1.85293 14.5629 2.32265 15.0325L3.8433 16.5532L3.87866 16.5178L3.8433 16.5532L11.4456 24.1551L11.4465 24.156L11.4541 24.1641ZM11.5025 18.1298L11.5378 18.1651L11.5732 18.1298L18.1294 11.574L18.1648 11.5386L18.1294 11.5032L16.4962 9.87014L16.4608 9.83479L16.4255 9.87014L9.86948 16.4261L9.83413 16.4615L9.86948 16.4968L10.6859 17.3134L10.7213 17.278L10.6859 17.3134L11.5025 18.1298ZM23.9723 14.6711L24.0077 14.6358L23.9723 14.6712C24.1998 14.8986 24.5027 15.024 24.8244 15.024C25.146 15.024 25.4486 14.8986 25.6761 14.6711C25.9037 14.4436 26.0292 14.141 26.0292 13.8192C26.0292 13.4975 25.9037 13.1948 25.6762 12.9673L24.1578 11.4489L24.1579 11.4489L24.1567 11.4478L24.1557 11.4469L24.1546 11.4458L16.5535 3.84506L16.5525 3.84396L16.5494 3.84062L16.5494 3.8406L16.5483 3.83951L15.0321 2.32337C14.8046 2.09587 14.5018 1.97045 14.1801 1.97045C13.8583 1.97045 13.5555 2.09587 13.3279 2.32344L13.3279 2.32345C12.8585 2.79317 12.8585 3.55753 13.3281 4.02738L13.3281 4.02738L17.1296 7.82855L20.1701 10.8688L20.1716 10.8705L20.1715 10.8705L20.1734 10.8724L23.9723 14.6711Z"
            fill="#1A1918"
            stroke="#1A1918"
            stroke-width="0.1"
          />
        </svg>

        <h3 translate>about.vision.card.two.title</h3>
        <p translate>about.vision.card.two.text</p>
      </div>
      <div class="grid-card">
        <svg
          width="28"
          height="34"
          viewBox="0 0 28 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.799805 2.11211C0.799805 1.44937 1.33706 0.912109 1.9998 0.912109H13.2498C14.2352 0.912109 14.6517 1.7307 14.7843 2.07791C14.9399 2.48554 15.0074 2.96926 15.0469 3.38488C15.0884 3.82205 15.1084 4.30668 15.1266 4.75664L15.128 4.79177C15.1301 4.84225 15.1321 4.89233 15.1341 4.942H25.9998C26.3936 4.942 26.7624 5.13526 26.9865 5.45911C27.2107 5.78296 27.2616 6.19617 27.1229 6.56476L24.2793 14.1186L27.1276 21.9513C27.2613 22.3192 27.2073 22.7292 26.9827 23.0499C26.7581 23.3705 26.3913 23.5614 25.9998 23.5614H16.2498C14.795 23.5614 13.8806 22.7079 13.3939 21.8066C13.175 21.4012 13.0297 20.9702 12.9376 20.5614H3.1998V32.1121C3.1998 32.7748 2.66255 33.3121 1.9998 33.3121C1.33706 33.3121 0.799805 32.7748 0.799805 32.1121V2.11211ZM3.1998 18.1614H12.7998V6.19205C12.7657 5.77473 12.7476 5.32684 12.7309 4.9121L12.7286 4.85354C12.7099 4.39074 12.6919 3.97267 12.6577 3.61192C12.6467 3.49674 12.6349 3.39726 12.6228 3.31211H3.1998V18.1614ZM15.1998 7.342V19.3614C15.1998 19.7269 15.2893 20.2655 15.5057 20.6663C15.694 21.015 15.9046 21.1614 16.2498 21.1614H24.2866L21.8721 14.5215C21.7741 14.2522 21.7758 13.9568 21.8767 13.6887L24.2659 7.342H15.1998Z"
            fill="#1A1918"
          />
        </svg>

        <h3 translate>about.vision.card.three.title</h3>
        <p translate>about.vision.card.three.text</p>
      </div>
      <div class="grid-card">
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.43246 16.9016C2.05165 10.9288 5.77421 4.96749 11.747 3.58667C15.5662 2.70374 19.3807 3.90742 21.996 6.4518L24.6816 5.83093C21.5281 1.99757 16.3708 0.0544316 11.2065 1.24835C3.94221 2.92772 -0.585234 10.178 1.09414 17.4422C1.50089 19.2017 3.7908 18.4517 3.43246 16.9016Z"
            fill="#1A1918"
          />
          <path
            d="M26.5617 13.2605C27.9425 19.2333 24.2199 25.1946 18.2471 26.5754C14.4279 27.4584 10.6134 26.2547 7.99815 23.7103L5.3125 24.3312C8.46602 28.1645 13.6233 30.1077 18.7877 28.9138C26.0519 27.2344 30.5794 19.9842 28.9 12.7199C28.4932 10.9604 26.2033 11.7104 26.5617 13.2605Z"
            fill="#1A1918"
          />
        </svg>

        <h3 translate>about.vision.card.four.title</h3>
        <p translate>about.vision.card.four.text</p>
      </div>
    </div>
  </div>

  <!-- Team -->
  <div class="about-team">
    <div class="top">
      <h2 translate>about.team.title</h2>
      <p translate>about.team.sub1</p>
      <p translate>about.team.sub2</p>
    </div>

    <div class="content-image">
      <div class="content-image-text">
        <div class="content-card">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.875 18.8613C4.875 16.5832 6.72183 14.7363 9 14.7363L27.3 14.7363C29.5782 14.7363 31.425 16.5832 31.425 18.8613L31.425 30.8613C31.425 32.3111 30.2497 33.4863 28.8 33.4863L7.5 33.4863C6.05025 33.4863 4.875 32.3111 4.875 30.8613L4.875 18.8613ZM9 16.9863C7.96447 16.9863 7.125 17.8258 7.125 18.8613L7.125 30.8613C7.125 31.0684 7.29289 31.2363 7.5 31.2363L28.8 31.2363C29.0071 31.2363 29.175 31.0684 29.175 30.8613L29.175 18.8613C29.175 17.8258 28.3355 16.9863 27.3 16.9863L9 16.9863Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5257 20.3639C13.0125 20.397 13.4226 20.7401 13.5409 21.2135C14.1138 23.5048 16.465 24.5613 18.4495 24.5613C19.0708 24.5613 19.5745 25.065 19.5745 25.6863C19.5745 26.3077 19.0708 26.8113 18.4495 26.8113C16.4963 26.8113 13.8596 26.0013 12.3445 23.9027C11.6001 24.813 10.7127 25.3705 9.77829 25.656C8.35352 26.0914 6.97548 25.8475 6.09374 25.5536C5.50431 25.3571 5.18577 24.72 5.38227 24.1306C5.57876 23.5411 6.21588 23.2226 6.80531 23.4191C7.42359 23.6252 8.29556 23.7564 9.12078 23.5042C9.88459 23.2708 10.7672 22.6629 11.405 21.0685C11.5862 20.6155 12.0389 20.3309 12.5257 20.3639Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.374 20.3639C23.8872 20.397 23.4771 20.7401 23.3588 21.2135C22.7859 23.5048 20.4347 24.5613 18.4502 24.5613C17.8289 24.5613 17.3252 25.065 17.3252 25.6863C17.3252 26.3077 17.8289 26.8113 18.4502 26.8113C20.3948 26.8113 23.0168 26.0084 24.535 23.9305C25.2128 24.8007 26.0047 25.3538 26.8635 25.6454C28.2105 26.1027 29.5015 25.8385 30.356 25.5536C30.9454 25.3571 31.2639 24.72 31.0674 24.1306C30.8709 23.5411 30.2338 23.2226 29.6444 23.4191C28.9988 23.6343 28.2649 23.745 27.5868 23.5148C26.9595 23.3018 26.1549 22.7191 25.4947 21.0685C25.3135 20.6155 24.8609 20.3309 24.374 20.3639Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.4497 8.36133C19.071 8.36133 19.5747 8.86501 19.5747 9.48633L19.5747 15.4863C19.5747 16.1076 19.071 16.6113 18.4497 16.6113C17.8284 16.6113 17.3247 16.1076 17.3247 15.4863L17.3247 9.48633C17.3247 8.86501 17.8284 8.36133 18.4497 8.36133Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.4497 9.86133C25.071 9.86133 25.5747 10.365 25.5747 10.9863L25.5747 15.4863C25.5747 16.1076 25.071 16.6113 24.4497 16.6113C23.8284 16.6113 23.3247 16.1076 23.3247 15.4863L23.3247 10.9863C23.3247 10.365 23.8284 9.86133 24.4497 9.86133Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.4497 9.86133C13.071 9.86133 13.5747 10.365 13.5747 10.9863L13.5747 15.4863C13.5747 16.1076 13.071 16.6113 12.4497 16.6113C11.8284 16.6113 11.3247 16.1076 11.3247 15.4863L11.3247 10.9863C11.3247 10.365 11.8284 9.86133 12.4497 9.86133Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.6542 3.35018C18.0936 2.91084 18.8059 2.91084 19.2452 3.35018L19.3362 3.44117C19.7755 3.88051 19.7755 4.59282 19.3362 5.03216C18.8969 5.4715 18.1845 5.4715 17.7452 5.03216L17.6542 4.94117C17.2149 4.50183 17.2149 3.78952 17.6542 3.35018Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.6542 6.35018C24.0936 5.91084 24.8059 5.91084 25.2452 6.35018L25.3362 6.44117C25.7755 6.88051 25.7755 7.59282 25.3362 8.03216C24.8969 8.4715 24.1845 8.4715 23.7452 8.03216L23.6542 7.94117C23.2149 7.50183 23.2149 6.78952 23.6542 6.35018Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.6542 6.35018C12.0936 5.91084 12.8059 5.91084 13.2452 6.35018L13.3362 6.44117C13.7755 6.88051 13.7755 7.59282 13.3362 8.03216C12.8969 8.4715 12.1845 8.4715 11.7452 8.03216L11.6542 7.94117C11.2149 7.50183 11.2149 6.78952 11.6542 6.35018Z"
              fill="#1A1918"
            />
          </svg>
          <p [innerHTML]="'about.team.card1' | translate"></p>
        </div>

        <div class="content-card">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.23323 24.488C5.57295 25.3181 4.94009 26.2735 4.94009 27.021C4.94009 27.7684 5.57295 28.7238 7.23323 29.5539C8.83161 30.3531 11.1122 30.8773 13.6877 30.8773C16.2633 30.8773 18.5439 30.3531 20.1423 29.5539C21.8025 28.7238 22.4354 27.7684 22.4354 27.021C22.4354 26.2735 21.8025 25.3181 20.1423 24.488C18.5439 23.6888 16.2633 23.1646 13.6877 23.1646C11.1122 23.1646 8.83161 23.6888 7.23323 24.488ZM6.30751 22.6366C8.24975 21.6654 10.8605 21.0946 13.6877 21.0946C16.515 21.0946 19.1257 21.6654 21.068 22.6366C22.9483 23.5767 24.5054 25.067 24.5054 27.021C24.5054 28.9749 22.9483 30.4652 21.068 31.4054C19.1257 32.3765 16.515 32.9473 13.6877 32.9473C10.8605 32.9473 8.24975 32.3765 6.30751 31.4054C4.42718 30.4652 2.87012 28.9749 2.87012 27.021C2.87012 25.067 4.42718 23.5767 6.30751 22.6366Z"
              fill="#1A1918"
            />
            <path
              d="M26.3401 27.6422C26.2466 28.4882 25.965 29.2434 25.563 29.9112C27.1156 29.6538 28.5249 29.2147 29.6925 28.6309C31.5728 27.6907 33.1299 26.2004 33.1299 24.2465C33.1299 22.2926 31.5728 20.8023 29.6925 19.8621C27.7502 18.891 25.1395 18.3202 22.3122 18.3202C20.0179 18.3202 17.8661 18.6961 16.0985 19.3568C17.7715 19.5394 19.3531 19.9118 20.7492 20.4558C21.2552 20.4128 21.7774 20.3902 22.3122 20.3902C24.8878 20.3902 27.1684 20.9144 28.7668 21.7135C30.427 22.5437 31.0599 23.499 31.0599 24.2465C31.0599 24.994 30.427 25.9493 28.7668 26.7795C28.0751 27.1253 27.2558 27.4196 26.3401 27.6422Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.6876 7.79169C11.1719 7.79169 9.13252 9.83108 9.13252 12.3468C9.13252 14.8625 11.1719 16.9019 13.6876 16.9019C16.2033 16.9019 18.2427 14.8625 18.2427 12.3468C18.2427 9.83108 16.2033 7.79169 13.6876 7.79169ZM7.06254 12.3468C7.06254 8.68786 10.0287 5.72172 13.6876 5.72172C17.3465 5.72172 20.3127 8.68786 20.3127 12.3468C20.3127 16.0057 17.3465 18.9719 13.6876 18.9719C10.0287 18.9719 7.06254 16.0057 7.06254 12.3468Z"
              fill="#1A1918"
            />
            <path
              d="M19.4045 6.06594C20.1934 5.41101 21.2069 5.01724 22.3123 5.01724C24.828 5.01724 26.8674 7.05663 26.8674 9.57233C26.8674 12.088 24.828 14.1274 22.3123 14.1274C22.2063 14.1274 22.1012 14.1238 21.997 14.1167C21.8479 14.8208 21.6115 15.4927 21.2998 16.1205C21.6299 16.1711 21.968 16.1974 22.3123 16.1974C25.9712 16.1974 28.9374 13.2313 28.9374 9.57233C28.9374 5.91341 25.9712 2.94727 22.3123 2.94727C20.505 2.94727 18.8667 3.67096 17.6714 4.84437C18.3003 5.17897 18.8822 5.59032 19.4045 6.06594Z"
              fill="#1A1918"
            />
          </svg>
          <p [innerHTML]="'about.team.card2' | translate"></p>
        </div>

        <div class="content-card">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.04994 22.2694C6.31745 23.1357 5.65707 24.1326 5.65707 24.9126C5.65707 25.6925 6.31745 26.6894 8.04994 27.5557C9.71783 28.3896 12.0976 28.9366 14.7852 28.9366C17.4727 28.9366 19.8525 28.3896 21.5204 27.5557C23.2529 26.6894 23.9133 25.6925 23.9133 24.9126C23.9132 24.1326 23.2529 23.1357 21.5204 22.2694C19.8525 21.4355 17.4727 20.8885 14.7852 20.8885C12.0976 20.8885 9.71783 21.4355 8.04994 22.2694ZM7.08396 20.3375C9.11067 19.3241 11.835 18.7285 14.7852 18.7285C17.7354 18.7285 20.4597 19.3241 22.4864 20.3375C24.4485 21.3185 26.0733 22.8737 26.0733 24.9126C26.0733 26.9515 24.4485 28.5066 22.4864 29.4876C20.4597 30.501 17.7354 31.0966 14.7852 31.0966C11.835 31.0966 9.11067 30.501 7.08396 29.4876C5.12185 28.5066 3.49707 26.9515 3.49707 24.9126C3.49707 22.8737 5.12185 21.3185 7.08396 20.3375Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.7858 4.84555C12.1606 4.84555 10.0326 6.97362 10.0326 9.59874C10.0326 12.2239 12.1606 14.3519 14.7858 14.3519C17.4109 14.3519 19.5389 12.2239 19.5389 9.59874C19.5389 6.97362 17.4109 4.84555 14.7858 4.84555ZM7.87256 9.59874C7.87256 5.78069 10.9677 2.68555 14.7858 2.68555C18.6038 2.68555 21.6989 5.78069 21.6989 9.59874C21.6989 13.4168 18.6038 16.5119 14.7858 16.5119C10.9677 16.5119 7.87256 13.4168 7.87256 9.59874Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28.6345 10.0307C28.1712 10.4941 28.1721 11.2441 28.6345 11.7065C30.745 13.8169 30.745 17.2534 28.6345 19.3638C28.1714 19.827 28.1714 20.5764 28.6345 21.0396C29.0977 21.5027 29.8471 21.5027 30.3103 21.0396C33.3459 18.004 33.3459 13.0663 30.3103 10.0307C29.8479 9.56833 29.0979 9.56742 28.6345 10.0307Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M26.5187 12.364C26.0563 11.9016 25.3063 11.9007 24.843 12.364C24.3796 12.8273 24.3806 13.5773 24.843 14.0398C25.6672 14.864 25.6672 16.2063 24.843 17.0305C24.3798 17.4937 24.3798 18.2431 24.843 18.7063C25.3061 19.1695 26.0556 19.1695 26.5187 18.7063C28.2675 16.9575 28.2675 14.1128 26.5187 12.364Z"
              fill="#1A1918"
            />
          </svg>
          <p [innerHTML]="'about.team.card3' | translate"></p>
        </div>

        <div class="content-card">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.6231 24.184L12.5132 24.5138L14.0674 26.2622C11.9596 26.5057 10.1099 26.9141 8.64987 27.4251C7.43045 27.8519 6.60401 28.3085 6.12639 28.7037C5.96132 28.8403 5.86614 28.9441 5.81252 29.0138C5.86614 29.0834 5.96132 29.1872 6.12639 29.3238C6.60401 29.719 7.43045 30.1756 8.64987 30.6024C11.0679 31.4487 14.555 32.0138 18.5132 32.0138C22.4713 32.0138 25.9584 31.4487 28.3765 30.6024C29.5959 30.1756 30.4224 29.719 30.9 29.3238C31.065 29.1872 31.1602 29.0834 31.2138 29.0138C31.1602 28.9441 31.065 28.8403 30.9 28.7037C30.4224 28.3085 29.5959 27.8519 28.3765 27.4251C26.8229 26.8814 24.8279 26.4537 22.5502 26.2174L24.2008 24.1543C29.6648 24.9385 33.5132 26.8188 33.5132 29.0138C33.5132 31.9133 26.7975 34.2638 18.5132 34.2638C10.2289 34.2638 3.51318 31.9133 3.51318 29.0138C3.51318 26.8461 7.26675 24.9852 12.6231 24.184ZM5.74806 28.9089C5.74844 28.9089 5.75038 28.913 5.75275 28.9214C5.74887 28.9131 5.74768 28.9089 5.74806 28.9089ZM5.74806 29.1186C5.74768 29.1186 5.74887 29.1144 5.75275 29.1061C5.75038 29.1145 5.74844 29.1186 5.74806 29.1186Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.5132 16.8617C19.673 16.8617 20.6132 15.9215 20.6132 14.7617C20.6132 13.6019 19.673 12.6617 18.5132 12.6617C17.3534 12.6617 16.4132 13.6019 16.4132 14.7617C16.4132 15.9215 17.3534 16.8617 18.5132 16.8617ZM18.5132 19.2617C20.9985 19.2617 23.0132 17.247 23.0132 14.7617C23.0132 12.2764 20.9985 10.2617 18.5132 10.2617C16.0279 10.2617 14.0132 12.2764 14.0132 14.7617C14.0132 17.247 16.0279 19.2617 18.5132 19.2617Z"
              fill="#1A1918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.88818 14.7617C6.88818 7.24125 13.5523 3.13672 18.5132 3.13672C23.474 3.13672 30.1382 7.24125 30.1382 14.7617C30.1382 18.1718 28.1646 21.3729 25.9599 24.176C24.9154 25.504 23.7755 26.7943 22.699 28.0129C22.6236 28.0983 22.5485 28.1833 22.4737 28.268C21.32 29.5748 20.2596 30.7881 19.4189 31.9291C19.2099 32.2127 18.8801 32.382 18.5278 32.3866C18.1755 32.3912 17.8415 32.2305 17.6252 31.9524C16.823 30.921 15.8254 29.8016 14.7374 28.5808C14.6772 28.5133 14.6167 28.4454 14.556 28.3773C13.4093 27.0902 12.1825 25.7047 11.0627 24.2649C8.85619 21.428 6.88818 18.1667 6.88818 14.7617ZM18.5132 5.38672C14.474 5.38672 9.13818 8.78219 9.13818 14.7617C9.13818 17.3568 10.6702 20.0954 12.8387 22.8835C13.9064 24.2562 15.0858 25.5895 16.236 26.8806C16.3029 26.9556 16.3697 27.0306 16.4365 27.1055C17.1495 27.9055 17.8518 28.6935 18.4928 29.4539C19.2045 28.5761 19.9919 27.6795 20.787 26.7789C20.859 26.6974 20.931 26.6158 21.0032 26.5341C22.0888 25.3051 23.1883 24.0604 24.1914 22.785C26.3618 20.0255 27.8882 17.3517 27.8882 14.7617C27.8882 8.78219 22.5523 5.38672 18.5132 5.38672Z"
              fill="#1A1918"
            />
          </svg>
          <p class="tt" [innerHTML]="'about.team.card4' | translate"></p>
        </div>
      </div>
      <img src="assets/images/about/team.png" alt="" />
    </div>
  </div>

  <!-- JOIN -->
  <div class="join">
    <div class="backdrop">
      <img src="assets/images/about/backdrop.png" alt="" />
    </div>
    <div class="content">
      <h2 translate>about.join.title</h2>
      <p translate>about.join.text</p>
      <a class="btn-primary" href="https://support.kinomap.com/hc/fr/categories/360005988152-OFFRES-D-EMPLOI" translate>about.join.btn</a>
    </div>
  </div>
</div>
